/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Input } from 'reactstrap';
import { InputProps } from './InputProps';
import { getAddonSingleElement } from './addonUtils';

export default function DateInput(props: InputProps & { label?: React.ReactNode }) {
  const {
    isDisabled,
    universalTracker,
    valueDataData: value,
    handleFocus,
    handleValueDataChange,
    placeholder,
    addons
  } = props;

  const label = ('label' in props) ? props.label : undefined;
  const disabled = isDisabled?.(props);
  const { beforeElement, afterElement, belowInputElement } = getAddonSingleElement(addons);

  const validValue = typeof value === 'string' || typeof value === 'undefined';
  if (!validValue) {
    return <>Unsupported data for date input</>;
  }

  return (
    <>
      <div className='position-relative input-group mb-3'>
        {beforeElement || null}
        {label ?? null}
        <Input
          type='date'
          autoComplete='off'
          className='styled-input'
          name={universalTracker.getId()}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          required={true}
          onFocus={handleFocus}
          onClick={handleFocus}
          onChange={(e) => handleValueDataChange(e.target.value)}
        />
        {afterElement || null}
      </div>
      {belowInputElement || null}
    </>
  );
}
